/*
 * DFC CLEAN DEPENDENT DROPDOWNS
 * For Shopify Craft
 *
 * Shopify/Craft remains the source of truth.
 * We never delete or rebuild Craft's native options.
 */

(() => {
  let syncing = false;

  function clean(text) {
    return (text || '')
      .replace(/\s*-\s*unavailable\s*$/i, '')
      .trim();
  }

  function unavailable(option) {
    return (option.textContent || '')
      .toLowerCase()
      .includes('unavailable');
  }

  function nativeSelects(picker) {
    return Array.from(
      picker.querySelectorAll(
        'select[name^="options["]:not(.dfc-clean-select)'
      )
    );
  }

  function createCleanPicker(picker) {
    if (!picker || picker.querySelector('.dfc-clean-picker')) {
      return;
    }

    const natives = nativeSelects(picker);

    if (!natives.length) return;

    picker.dataset.dfcReady = 'true';

    const container = document.createElement('div');
    container.className = 'dfc-clean-picker';

    natives.forEach((nativeSelect, index) => {
      const nativeWrapper = nativeSelect.closest(
        '.product-form__input--dropdown'
      );

      if (!nativeWrapper) return;

      /*
       * Build customer-facing field.
       */
      const field = document.createElement('div');

      field.className =
        'product-form__input product-form__input--dropdown dfc-clean-field';

      const nativeLabel =
        nativeWrapper.querySelector('.form__label');

      const label = document.createElement('label');
      label.className = 'form__label';

      label.textContent =
        nativeLabel?.textContent?.trim() ||
        `Option ${index + 1}`;

      const selectWrapper = document.createElement('div');
      selectWrapper.className = 'select';

      const cleanSelect = document.createElement('select');

      cleanSelect.className =
        'select__select dfc-clean-select';
      cleanSelect.id = 'dfc-clean-' + nativeSelect.id;
      label.htmlFor = cleanSelect.id;

      /*
       * Copy ONLY currently valid options.
       *
       * Style normally contains all Styles.
       * After Style is selected, Shopify returns the
       * appropriate Color availability.
       * After Color is selected, Shopify returns Size.
       */
      Array.from(nativeSelect.options).forEach(option => {
        if (unavailable(option)) return;

        const copy = document.createElement('option');

        copy.value = option.value;
        copy.textContent = clean(option.textContent);

        if (option.selected) {
          copy.selected = true;
        }

        cleanSelect.appendChild(copy);
      });

      /*
       * Safety fallback:
       * If Shopify somehow marks the current selection
       * unavailable, don't leave an empty dropdown.
       */
      if (!cleanSelect.options.length) {
        Array.from(nativeSelect.options).forEach(option => {
          const copy = document.createElement('option');

          copy.value = option.value;
          copy.textContent = clean(option.textContent);

          if (option.selected) {
            copy.selected = true;
          }

          cleanSelect.appendChild(copy);
        });
      }

      selectWrapper.appendChild(cleanSelect);

      /*
       * Caret, matching Craft.
       */
      const caret = nativeWrapper.querySelector(
        '.svg-wrapper'
      );

      if (caret) {
        selectWrapper.appendChild(
          caret.cloneNode(true)
        );
      }

      field.appendChild(label);
      field.appendChild(selectWrapper);

      container.appendChild(field);

      /*
       * Hide Craft's original field visually.
       * DO NOT remove it.
       */
      nativeWrapper.classList.add(
        'dfc-native-hidden'
      );

      /*
       * Customer changes our clean dropdown.
       */
      cleanSelect.addEventListener('change', event => {
        event.stopPropagation();
        if (syncing) return;

        syncing = true;

        /*
         * Re-find native select in case something
         * changed in the DOM.
         */
        const currentNatives =
          nativeSelects(picker);

        const currentNative =
          currentNatives[index];

        if (!currentNative) {
          syncing = false;
          return;
        }

        const matchingOption =
          Array.from(currentNative.options)
            .find(option =>
              option.value === cleanSelect.value
            );

        if (!matchingOption) {
          syncing = false;
          return;
        }

        /*
         * Set the real Shopify/Craft option.
         */
        currentNative.value =
          matchingOption.value;

        /*
         * Craft's VariantSelects connectedCallback
         * listens for this.
         */
        currentNative.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );

        /*
         * Craft will now fetch new HTML and replace
         * the entire variant-selects element.
         */
        setTimeout(() => {
          syncing = false;
        }, 100);
      });
    });

    /*
     * Put clean picker before Craft's hidden fields.
     */
    picker.prepend(container);
  }

  function initialize() {
    document
      .querySelectorAll('variant-selects')
      .forEach(createCleanPicker);
  }

  /*
   * Initial page.
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );
  } else {
    initialize();
  }

  /*
   * THIS is the important part for Craft.
   *
   * ProductInfo.updateOptionValues() replaces the
   * entire variant-selects element after every choice.
   *
   * MutationObserver sees the NEW picker and builds
   * our clean interface from Shopify's fresh results.
   */
  const observer = new MutationObserver(
    mutations => {
      let foundNewPicker = false;

      for (const mutation of mutations) {
        if (mutation.target instanceof HTMLElement && mutation.target.closest('variant-selects')) {
          foundNewPicker = true;
          break;
        }
        for (const node of mutation.addedNodes) {
          if (!(node instanceof HTMLElement)) {
            continue;
          }

          if (
            node.matches?.('variant-selects') ||
            node.querySelector?.('variant-selects')
          ) {
            foundNewPicker = true;
            break;
          }
        }

        if (foundNewPicker) break;
      }

      if (foundNewPicker) {
  queueMicrotask(() => {
    initialize();

    /*
     * After Craft replaces the picker, check whether
     * Shopify left Color or Size on an unavailable value.
     *
     * If our clean picker has already moved to the first
     * valid choice, send that choice back through Craft.
     */
    document
      .querySelectorAll('variant-selects')
      .forEach(picker => {
        const natives = nativeSelects(picker);
        const cleans = Array.from(
          picker.querySelectorAll('.dfc-clean-select')
        );

        if (natives.length < 2 || cleans.length < 2) {
          return;
        }

        /*
         * COLOR
         */
        const nativeColor = natives[1];
        const cleanColor = cleans[1];

        const nativeColorOption =
          nativeColor.selectedOptions[0];

        if (
          nativeColorOption &&
          unavailable(nativeColorOption) &&
          cleanColor.value
        ) {
          const validColor =
            Array.from(nativeColor.options).find(
              option =>
                option.value === cleanColor.value &&
                !unavailable(option)
            );

          if (validColor) {
            nativeColor.value = validColor.value;

            nativeColor.dispatchEvent(
              new Event('change', {
                bubbles: true
              })
            );

            return;
          }
        }

        /*
         * SIZE
         */
        if (natives.length >= 3 && cleans.length >= 3) {
          const nativeSize = natives[2];
          const cleanSize = cleans[2];

          const nativeSizeOption =
            nativeSize.selectedOptions[0];

          if (
            nativeSizeOption &&
            unavailable(nativeSizeOption) &&
            cleanSize.value
          ) {
            const validSize =
              Array.from(nativeSize.options).find(
                option =>
                  option.value === cleanSize.value &&
                  !unavailable(option)
              );

            if (validSize) {
              nativeSize.value = validSize.value;

              nativeSize.dispatchEvent(
                new Event('change', {
                  bubbles: true
                })
              );
            }
          }
        }
      });
  });
}
    }
  );

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  /*
   * Shopify theme editor.
   */
  document.addEventListener(
    'shopify:section:load',
    initialize
  );

  /*
   * Safari back/forward cache.
   */
  window.addEventListener(
    'pageshow',
    initialize
  );
})();
